var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFormOfPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 33,
    viewBox: "0 0 49 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.399157,
    y: 0.399157,
    width: 24.1706,
    height: 16.6799,
    rx: 1.19747,
    stroke: "white",
    strokeWidth: 0.798314
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.832397,
    y: 4.16296,
    width: 23.3043,
    height: 3.32919,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.49683,
    y: 12.4841,
    width: 8.32298,
    height: 0.832298,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6582,
    y: 16.1221,
    width: 23.6967,
    height: 16.0863,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5626 23.3207L36.3627 23.3207L38.5 21.1834C38.6766 21.0082 38.776 20.7697 38.776 20.5207C38.776 20.2717 38.6766 20.0332 38.5 19.858C38.3252 19.6843 38.0885 19.5865 37.842 19.5865C37.5954 19.5865 37.3589 19.6843 37.1839 19.858L33.4506 23.5913C33.2739 23.7665 33.1746 24.0051 33.1746 24.254C33.1746 24.503 33.2739 24.7415 33.4506 24.9168L37.1839 28.6501C37.3579 28.8224 37.5925 28.9197 37.8372 28.9207C38.0854 28.9221 38.3239 28.8246 38.5 28.6501C38.6766 28.4749 38.776 28.2363 38.776 27.9874C38.776 27.7384 38.6766 27.4999 38.5 27.3246L36.3627 25.1874L47.5626 25.1874C47.896 25.1874 48.2041 25.0094 48.371 24.7207C48.5376 24.4319 48.5376 24.0761 48.371 23.7874C48.2041 23.4986 47.896 23.3207 47.5626 23.3207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4681 23.886V6.69849H34.4574",
    stroke: "white",
    strokeWidth: 2.00365,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.39464,
    y: 15.7894,
    width: 24.1706,
    height: 16.6799,
    rx: 1.19747,
    stroke: "white",
    strokeWidth: 0.798314
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5688,
    y: 19,
    width: 10.5472,
    height: 0.999051,
    transform: "rotate(90 11.5688 19)",
    fill: "#0AA8E3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 10.5472,
    height: 0.901062,
    transform: "rotate(90 13 19)",
    fill: "#0AA8E3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 19,
    width: 10.5472,
    height: 2.07643,
    transform: "rotate(90 16 19)",
    fill: "#0AA8E3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 10.5472,
    height: 2.07643,
    transform: "rotate(90 21 19)",
    fill: "#0AA8E3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6545,
    y: 18.9825,
    width: 10.5472,
    height: 0.944088,
    transform: "rotate(90 24.6545 18.9825)",
    fill: "#0AA8E3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 10.5472,
    height: 0.944088,
    transform: "rotate(90 18 19)",
    fill: "#0AA8E3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    width: 10.5472,
    height: 0.944088,
    transform: "rotate(90 23 19)",
    fill: "#0AA8E3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFormOfPayment);
export default __webpack_public_path__ + "static/media/ic-form-of-payment.5a663544755aef0380261e8751082f3f.svg";
export { ForwardRef as ReactComponent };